import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Garages', to: '/garages' },
  { label: 'Venues', to: '/venues' },
  { label: 'Events', to: '/events' },
  { label: 'Teams', to: '/teams' },
  { label: 'Cities', to: '/cities' },
];

export default function NavBarLight() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl border-2 border-gray-900">
              <ArrowUpRight className="w-5 h-5" style={{ color: '#17A24A' }} strokeWidth={2.5} />
            </span>
            <span className="text-lg font-bold tracking-tight text-gray-900">ParkingRank</span>
          </Link>

          {/* Center nav */}
          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                className="flex items-center gap-1 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Right actions */}
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/methodology" className="text-sm font-medium text-gray-700 hover:text-gray-900">
              How scoring works
            </Link>
            <Link
              to="/garages"
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold text-white transition-opacity hover:opacity-90"
              style={{ backgroundColor: '#17A24A' }}
            >
              Find a garage <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>

          {/* Mobile toggle */}
          <button
            className="lg:hidden p-2 text-gray-700"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white px-4 py-4 space-y-1">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              onClick={() => setOpen(false)}
              className="block py-2 text-sm font-medium text-gray-700"
            >
              {l.label}
            </Link>
          ))}
          <div className="pt-3 flex items-center gap-3">
            <Link to="/methodology" onClick={() => setOpen(false)} className="text-sm font-medium text-gray-700">
              How it works
            </Link>
            <Link
              to="/garages"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-semibold text-white"
              style={{ backgroundColor: '#17A24A' }}
            >
              Find a garage
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
